import { range } from 'lodash';
import { useMemo } from 'react';

const MIN_SINGLE_ELIMINATION_RANK_COUNTS = 1;

export const useTournamentDistributionRanks = (
  places: number[][],
  isKnockoutTournament: boolean
): number[] => {
  const ranks = useMemo(() => {
    const ranksCount = places.length;

    if (!ranksCount || ranksCount < MIN_SINGLE_ELIMINATION_RANK_COUNTS) {
      return [];
    }

    if (!isKnockoutTournament) {
      return range(ranksCount, 0, -1);
    }

    const result = [];
    for (let i = 0; i < ranksCount; i++) {
      result.push((ranksCount - i) * places[i].length);
    }
    return result;
  }, [isKnockoutTournament, places]);

  return ranks;
};
